// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"TrailerScreen_buttonsContainer__gA234","button":"TrailerScreen_button__+gexY"};